<template>
  <v-select
    v-model="selectedEventStatus"
    :items="eventsStatusesList"
    item-text="text"
    item-value="id"
    placeholder="Estatus de Evento"
    outlined
    dense
    :clearable="clearable"
    multiple
  >
  </v-select>
</template>

<script>
import { computed, onMounted } from '@vue/composition-api'
import useEventsStatusesList from '@/components/lists/eventsStatuses'

export default {
  props: {
    default: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { eventsStatusesList } = useEventsStatusesList()
    const selectedEventStatus = computed({
      get() {
        return props.value
      },
      set(value) {
        // Actualiza el valor del componente y emite el evento "input"
        // para mantener sincronizado el valor con v-model
        return emit('input', value)
      },
    })

    const Reset = () => {
      emit('input', props.default)
    }

    onMounted(() => {
      Reset()
    })

    return {
      selectedEventStatus,
      eventsStatusesList,
      Reset,
    }
  },
}
</script>
